export default "__VITE_ASSET__DRqMCCdy__"